<template>
  <section>
    <b-skeleton-img v-if="!sliderData"></b-skeleton-img>
    <div
      v-if="sliders.length&&sliderData"
      id="top-slider"
      style="height: 173px;"
      class="top-slider home-slider  "
    >
      <div class="swiper-container h-100">
        <div class="swiper-wrapper">
          <div
            v-for="slider in sliders"
            :key="slider.id"
            class="swiper-slide bg-color-ea"
          >
            <div
              v-if="slider.description"
              class="
                top-slider-content
                d-flex
                justify-content-between
                container
                mx-auto
              "
            >
              <div class="text-right my-auto ml-3">
                <span
                  class="
                    top-header-discount
                    bg-color-themeRed
                    fontsize-mini
                    text-white
                    px-2
                  "
                  v-if="slider.custom_fields && slider.custom_fields.discount"
                  >{{ slider.custom_fields.discount }}</span
                >
                <h5
                  class="font-weight-bold fontsize-heavy mb-3 mt-sm-3 mt-2 text-color-444"
                >
                  {{ slider.title }}
                </h5>
                <p
                  class="
                    fontsize-medium
                    text-justify text-color-444
                    line-height2
                    d-lg-block d-none
                  "
                >
                  {{ slider.description }}
                </p>
                <div>
                  <router-link
                    v-if="slider.linkable_type != null"
                    :to="findUrl(slider.linkable_type, slider.linkable_id)"
                  >
                    <button
                      type="button"
                      class="
                        top-slider-cart
                        text-white
                        bg-color-theme
                        fontsize-mini
                        weight-bold
                        py-md-2 py-1
                        px-md-3 px-2
                        ml-md-3 ml-2
                      "
                    >
                      خرید این محصول
                    </button>
                  </router-link>
                  <a v-else :href="slider.link">
                    <button
                      type="button"
                      class="
                        top-slider-cart
                        text-white
                        bg-color-theme
                        fontsize-mini
                        weight-bold
                        py-md-2 py-1
                        px-md-3 px-2
                        ml-md-3 ml-2
                      "
                    >
                      خرید این محصول
                    </button>
                  </a>

                  <router-link
                    v-if="slider.linkable_type != null"
                    :to="findUrl(slider.linkable_type, slider.linkable_id)"
                  >
                    <button
                      type="button"
                      class="
                        top-slider-more
                        d-md-inline-block d-none
                        text-color-666
                        fontsize-mini
                        py-md-2 py-1
                        px-md-3 px-2
                        bg-none
                      "
                    >
                      اطلاعات بیشتر ...
                    </button>
                  </router-link>

                  <a v-else :href="slider.link">
                    <button
                      type="button"
                      class="
                        top-slider-more
                        d-md-inline-block d-none
                        text-color-666
                        fontsize-mini
                        py-md-2 py-1
                        px-md-3 px-2
                        bg-none
                      "
                    >
                      اطلاعات بیشتر ...
                    </button>
                  </a>
                </div>
              </div>
            </div>
            <DynamicLinker class="top-slider-img" :item="slider">
              <img
                :src="slider.image.url"
                class="w-100 h-100"
                :alt="slider.title"
              />
            </DynamicLinker>
          </div>
        </div>
        <div class=" swiper-pagination"></div>
      </div>
      <div class="d-md-block d-none swiper-button-next text-center">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="30"
          height="30"
          fill="currentColor"
          class="bi bi-chevron-compact-right"
          viewBox="0 0 16 16"
        >
          <path
            fill-rule="evenodd"
            d="M6.776 1.553a.5.5 0 0 1 .671.223l3 6a.5.5 0 0 1 0 .448l-3 6a.5.5 0 1 1-.894-.448L9.44 8 6.553 2.224a.5.5 0 0 1 .223-.671z"
            fill="#999"
          />
        </svg>
      </div>
      <div class="d-md-block d-none swiper-button-prev">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="30"
          height="30"
          fill="currentColor"
          class="bi bi-chevron-compact-left"
          viewBox="0 0 16 16"
        >
          <path
            fill-rule="evenodd"
            d="M9.224 1.553a.5.5 0 0 1 .223.67L6.56 8l2.888 5.776a.5.5 0 1 1-.894.448l-3-6a.5.5 0 0 1 0-.448l3-6a.5.5 0 0 1 .67-.223z"
            fill="#999"
          />
        </svg>
      </div>
    </div>
    <div class="gallery-box  container" v-if="sliders.length&&sliderData">
      <figure v-for="(slider,index) in sliders" :key="index">
     
        <DynamicLinker  :item="slider">
          <img
            :src="slider.image.url"
            class="w-100 h-100"
            :alt="slider.title"
          />
        </DynamicLinker>
      </figure>
   
    </div>
  </section>
</template>

<script>
import Swiper from "swiper/swiper-bundle.min.js";

import findUrl from "@/libraries/links/LinkResolver";

import DynamicLinker from "./DynamicLinker";
// import SearchButton from "../header/SearchButton";
import { BSkeletonImg } from "bootstrap-vue";

export default {
  name: "slider",
  components: {
    // SearchButton,

    DynamicLinker,
    BSkeletonImg,
  },
  watch: {
    sliderData() {
      // پاک کردن سویپر برای نمایش درست اسلایدر
      this.initHeaderSwiper(true);
    },
  },
  inject: ["mediaQueries"],
  methods: {
    getSlidersFromServer() {
      this.$store.dispatch("front/getSlidersFromServer");
    },
    findUrl,
    getSliderCustomFields(slider) {
      return JSON.parse(slider.custom_fields);
    },

    onResize() {
      let topSliderH = document.querySelector(".top-slider");
      let bodyWidth = document.body.offsetWidth;
      if (topSliderH) {
        if (bodyWidth < 767) {
          // topSliderH.style.height = bodyWidth / 1.6 + "px"; 
        } else {
          // topSliderH.style.height = bodyWidth / 2.2 + "px";
        }
      }
    },
    initHeaderSwiper(kill = false) {
      this.initSwiper("header-swiper", kill, () => {
        new Swiper(".top-slider .swiper-container", {
          spaceBetween: 0,
          //   centeredSlides: true,
          loop:true,
          breakpoints: {
            1024: {
              slidesPerView: 1,
              spaceBetween: 10,
            },
            768: {
              slidesPerView: 1,
              spaceBetween: 10,
            },
            570: {
              slidesPerView: 1.2,
              spaceBetween: 10,
              centeredSlides: true,
            },
            320: {
              slidesPerView: 1.2,
              spaceBetween: 7,
              centeredSlides: true,
            },
          },
          speed: 1000,
          loop: true,
          autoplay: {
            delay: 4500,
            disableOnInteraction: false,
          },
          pagination: {
            el: ".top-slider .swiper-pagination",
            clickable: true,
          },
          navigation: {
            nextEl: ".top-slider .swiper-button-next",
            prevEl: ".top-slider .swiper-button-prev",
          },
        });
      });
      this.$nextTick(() => {
        this.onResize();
      });
    },
  },
  mounted() {
    // ست کردن تنظیمات  برای اسکرول صفحه در برابر رسپانسیو
    window.removeEventListener("resize", this.onResize);
    window.addEventListener("resize", this.onResize);
    window.addEventListener("scroll", this.showHeader);
    if (!this.sliderData) {
      this.getSlidersFromServer();
    }
    //CHange height of top-slider
    const topSliderH = document.querySelector(".top-slider");
    const bodyWidth = document.body.offsetWidth;
    if (topSliderH) {
      if (bodyWidth < 767) {
        topSliderH.style.height = bodyWidth / 1.6 + "px";
      } else {
        topSliderH.style.height = bodyWidth / 2.2 + "px";
      }
    }

    window.removeEventListener("resize", this.onResize);
    window.addEventListener("resize", this.onResize);
    window.addEventListener("scroll", this.showHeader);
  },
  computed: {
    // دریافت دیتا از سمت ویوایکس
    sliderData() {
      return this.$store.getters["front/getSliders"];
    },
    sliders() {
      let sliders;

      if (this.mediaQueries.medium) {
        sliders = this.sliderData.sliders.filter((s) =>
          s.group.includes("mobile")
        );
      } else {
        sliders = this.sliderData.sliders.filter(
          (s) => !s.group.includes("mobile")
        );
      }
      sliders.forEach((slider) => {
        try {
          slider.custom_fields = this.getSliderCustomFields(slider);
        } catch (e) { }
      });

      return sliders;
    },
  },
};
</script>

<style scoped>
.gallery-box {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 1.5rem;
  margin-top: 2rem;
}
.home-slider {
  display: none;
}
.gallery-box figure img {
  width: 100%;
}

.gallery-box figure {
  margin: 0;
}

.gallery-box figure:nth-child(1) {
  grid-column: 1/4;
  aspect-ratio: 4/2.5;
}

.gallery-box figure:nth-child(2) {
  grid-column: 4/7;
  aspect-ratio: 4/2.5;
}

.gallery-box figure:nth-child(3) {
  grid-column: 1/3;
  aspect-ratio: 2/1;


}

.gallery-box figure:nth-child(4) {
  grid-column: 3/5;

  aspect-ratio: 2/1;
}

.gallery-box figure:nth-child(5) {
  grid-column: 5/7;
  aspect-ratio: 2/1;
}

.top-slider {
  /*height: 550px !important;*/

}

@media screen and (max-width: 639px) {
  
  
  .home-slider{
    display: block;
    margin-top: 2rem;

  }
  .gallery-box {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    gap: 1rem;
    display: none;
  }


  .gallery-box figure {
    grid-column: unset !important;
  }

  .gallery-box figure:nth-child(1) {
    aspect-ratio: 2/1;

  }

  .gallery-box figure:nth-child(2) {
    aspect-ratio: 2/1;

  }

}
</style>
<style>
.home-slider .swiper-pagination{
  display: none !important;
}
</style>
